import Loadable from 'react-loadable';

const LoadableConsentTermContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "consentTermContainer" */ './index'),
  loading: () => null,
});

export default LoadableConsentTermContainer;
